import "./Button.css";

export default function Button(props) {

    return <button className="icon-button"
        title={props.text}
        onClick={props.onClick}
        disabled={props.disabled}
    >
        {props.icon ? <img src={props.icon} alt={`${props.text} Icon`}/> : null}
        <p>{props.text}</p>
    </button>
}